import { render, staticRenderFns } from "./org-user-detail.vue?vue&type=template&id=30760af4&"
import script from "./org-user-detail.vue?vue&type=script&lang=js&"
export * from "./org-user-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports